<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h5 class="vue-title">
          <strong>{{ $t("NOTIFICATION") }}</strong>
        </h5>
        <div>
          <br />
          <b-form class="formTextSize" @submit.prevent="submitForm">
            <b-row>
              <b-col sm="3">
                <b-form-group id="addressField" label-for="input-1">
                  <span>
                    {{ $t("DESTINATION") }}
                    <span class="mandotry-color">*</span>
                  </span>
                  <b-form-select
                    id="authority"
                    v-model.trim="$v.notificationForm.notify_type.$model"
                    :options="notificationTypes"
                    value-field="id"
                    range
                    text-field="name"
                  ></b-form-select>
                  <show-errors
                    :control="$v.notificationForm.notify_type"
                    :field="$t('MANDATORY')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group id="addressField" label-for="input-1">
                  <span>
                    {{ $t("SUBJECT") }}
                    <span class="mandotry-color">*</span>
                  </span>
                  <b-form-input
                    v-model.trim="$v.notificationForm.title.$model"
                    class="inputField"
                    type="text"
                    autocomplete="off"
                    :maxlength="CONSTANTS.title"
                  ></b-form-input>
                  <show-errors
                    :control="$v.notificationForm.title"
                    :field="$t('MANDATORY')"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="6">
                <b-form-group id="addressField" label-for="input-1">
                  <span>
                    {{ $t("CONTENT") }}
                    <span class="mandotry-color">*</span>
                  </span>

                  <vue-editor 
                  class="custom-text-color"
                    v-model.trim="$v.notificationForm.message.$model"
                    autocomplete="off"
                    :editor-toolbar="customToolbar"
                  ></vue-editor>

                  <show-errors
                    :control="$v.notificationForm.message"
                    :field="$t('MANDATORY')"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-form-group>
                <b-form-radio-group
                  id="radio-group-1"
                  v-model.trim="$v.notificationForm.notify_on.$model"
                  :options="options"
                  v-on:change="getSelectedItem"
                  name="radio-options"
                ></b-form-radio-group>
                <show-errors
                  :control="$v.notificationForm.notify_on"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-row>
            <b-row v-if="this.notificationForm.notify_on === 'schedule'">
              <b-col sm="3">
                <b-form-group id="addressField" label-for="input-1">
                  <span>{{ $t("DATEFROMTO") }}</span>
                  <date-picker
                    :lang="lang"
                    class="datePickerCss custom-date-picker"
                    placeholder="YYYY-MM-DD"
                    v-model.trim="$v.notificationForm.notify_date.$model"
                    type="date"
                    :disabled-date="notBeforeDate"
                    :editable="true"
                    valuetype="DD/MM/YYYY"
                    format="YYYY-MM-DD"
                    @click="toggleTimePanel"
                  ></date-picker>
                  <show-errors
                    :control="$v.notificationForm.notification_Start_From"
                    :field="$t('MANDATORY')"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <br />
                <date-picker
                  v-if="!this.istime"
                  @keypress="timeFormat($event)"
                  v-model.trim="$v.notificationForm.notify_time.$model"
                  value-type="format"
                  type="time"
                  format="HH:mm"
                  :minute-step="30"
                  placeholder="HH:MM"
                  :default-value="new Date()"
                  :disabled-time="notBeforeTime"
                  :time-picker-options="{
                    start: '00:00',
                    step: '00:05',
                    end: '23:59'
                  }"
                ></date-picker>
              </b-col>
            </b-row>
            <b-row v-if="this.notificationForm.notify_on === 'schedule'">
              <b-col sm="3">
                <b-form-group id="addressField" label-for="input-1">
                  <b-form-checkbox
                    v-model="this.istime"
                    name="check-button"
                    switch
                    v-on:change="updateDateTogle"
                  >
                    <strong>時間指定なし</strong>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="8" class="text-center">
                <b-button
                  class="btn btn-secondary formTextSizeBlack mr-2"
                  to="/notification"
                  >{{ $t("CANCEL") }}</b-button
                >
                <button class="btn btn-primary formTextSizeBlack" type="submit">
                  {{ $t("ADDTO") }}
                </button>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
import ShowErrors from "@/components/ShowErrors";
import { CONSTANTS } from "@/shared/utils";
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import {
  CREATE_NOTIFICATION,
  GET_NOTIFICATION,
  EDIT_NOTIFICATION
} from "@/store/actions.type";
import { pickAs } from "@/shared/utils.js";

export default {
  name: "addNotification",
  components: { ShowErrors, DatePicker, VueEditor },
  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ] /* displaying only selected features in editor */,
      CONSTANTS: CONSTANTS,
      options: [
        { text: "スケジュール", value: "schedule" },
        { text: "すぐに", value: "immediate" }
      ],
      /* notification Types */
      notificationTypes: [
        { name: "すべて", id: "all" },
        { name: "提携先", id: "partner" },
        { name: "ユーザー", id: "user" }
      ],
      /* Date-picker Customization */
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
          weekdaysMin: ["日", "月", "火", "水", "木", "金", "土"]
        },
        monthBeforeYear: false
      },
      istime: true,
      notificationForm: {
        notify_type: "all",
        title: "",
        message: "",
        notify_date: "",
        notify_on: "",
        notify_time: ""
      },
      pickAs: pickAs
    };
  },

  /*validation for the Each fields in From */
  validations: {
    notificationForm: {
      notify_type: { required },
      title: { required },
      message: { required },
      notify_date: {},
      notify_on: { required },
      notify_time: {}
    }
  },
  methods: {
    getDateFormet(date) {
      return moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
    },
    /* Disable Date : Input : Date , Output : current and Feature Time*/
    notBeforeDate(date) {
      return date < new Date().setDate(new Date().getDate() - 1);
    },
    /* Disable Date */
    notBeforeTime(date) {
      if (new Date(this.notificationForm.notify_date) > date) {
        return 0;
      } else {
        return date < new Date().setDate(new Date().getDate());
      }
    },
    /* To update when  No time specified from the User */
    updateDateTogle(evt) {
      if (!evt) {
        var today = new Date();
        let hours =
          today.getHours() < 10 ? "0" + today.getHours() : today.getHours();
        let minute =
          today.getMinutes() < 10
            ? "0" + today.getMinutes()
            : today.getMinutes();
        this.notificationForm.notify_time =
          hours + ":" + 5 * Math.ceil(minute / 5);
      } else {
        this.notificationForm.notify_time = "";
      }
      this.istime = evt;
    },
    getSelectedItem(data) {
      this.notificationForm.notify_on = data;
      // this.notify_time = "";
      // this.notify_date = "";
    },

    /**
     * Sumbitting the Filled Form
     * Input @param {object} object  this.createPartner object which is filled by the user / in Edit also Using the same function
     * Output @param {boolean}   response Boolean status Api call (true =  success, false = failed)
     */
    async submitForm(evt) {
      this.$v.$touch();

      if (!this.$v.notificationForm.$invalid) {
        let dateNotify = moment(this.notificationForm.notify_date).format(
          "YYYY-MM-DD"
        );
        let dateTime = moment(
          dateNotify + " " + this.notificationForm.notify_time
        );

        /* Checking validatin for date and time picker */
        if (
          this.notificationForm.notify_on === "schedule" &&
          !this.istime &&
          this.notBeforeTime(new Date(dateTime))
        ) {
          this.$toast.error({
            message: this.$t("SELECTPROPERTIME")
          });
          return;
        }
        if (
          this.notificationForm.notify_on === "schedule" &&
          this.notBeforeDate(this.notificationForm.notify_date)
        ) {
          this.$toast.error({
            message: this.$t("SELECTPROPERDATE")
          });
          return;
        }
        if (
          this.notificationForm.notify_on === "schedule" &&
          this.notificationForm.notify_date == ""
        ) {
          this.$toast.error({
            message: this.$t("SELECTPROPERDATE")
          });
          return;
        } else if (
          this.notificationForm.notify_on === "schedule" &&
          !this.istime &&
          this.notificationForm.notify_time === ""
        ) {
          this.$toast.error({
            message: this.$t("SELECTPROPERTIME")
          });
          return;
        }

        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });

        /* Triggering edit api if it is Edit */
        if (_.get(this.params, "id", 0)) {
          let payload = Object.assign({}, this.notificationForm);
          payload["id"] = this.params.id;
          if (this.notificationForm.notify_on === "schedule") {
            payload["notify_date"] = moment(payload.notify_date).format(
              "YYYY-MM-DD"
            );
            //   /* convert local time to UTC time */
            //    console.log("convertin", payload["notify_time"])

            //   let ISOTime = moment(dateTime).toISOString();
            //   payload["notify_time"] = ISOTime.split("T")[1].replace(".000Z", "");
            //    console.log(" payload[notify_time]", payload["notify_time"])
          }

          let response = await this.$store.dispatch(EDIT_NOTIFICATION, payload);
          this.isLoading.hide();
          if (_.get(response, "status", false)) {
            this.$toast.success({
              message: _.get(response, "message", "")
            });
            this.$router.push({
              name: "notication"
            });
          } else {
            this.$toast.error({
              message: _.get(response, "message", "")
            });
          }
        } else {
          /*else part we are just calling the create api */
          let payload = Object.assign({}, this.notificationForm);
          if (this.notificationForm.notify_on === "schedule") {
            payload["notify_date"] = moment(payload.notify_date).format(
              "YYYY-MM-DD"
            );
            //   /* convert local time to UTC time */
            //   let ISOTime = moment(dateTime).toISOString();
            //   payload["notify_time"] = ISOTime.split("T")[1].replace(".000Z", "");
          }

          let response = await this.$store.dispatch(
            CREATE_NOTIFICATION,
            payload
          );
          this.isLoading.hide();
          if (_.get(response, "status", false)) {
            this.$toast.success({
              message: _.get(response, "message", "")
            });
            this.$router.push({
              name: "notication"
            });
          } else {
            this.$toast.error({
              message: _.get(response, "message", "")
            });
          }
        }
      }
    }
  },
  async created() {
    this.CONSTANTS = CONSTANTS;
    /*prefilling the form if it EditPage*/
    this.params = this.$route.params;
    if (_.get(this.params, "id", 0)) {
      this.istime = false;
      let data = await this.$store.dispatch(GET_NOTIFICATION, {
        id: _.get(this.params, "id", 0)
      });
      if (_.get(data, "status", 0)) {
        /*Prefilling the indivisual  fields in the forn */
        this.notificationForm = this.pickAs(data.notification, {
          notify_type: "notify_type",
          title: "title",
          message: "message",
          notify_date: "notify_date",
          notify_on: "notify_on",
          notify_time: "notify_time"
        });
      }
      if (_.get(data.notification, "notify_time") === null) this.istime = true;

      /*Converting the api response date  to Date format  which is in String format */
      this.notificationForm.notify_date = new Date(
        this.notificationForm.notify_date
      );
    }
  }
};
</script>
<style>
.custom-text-color{
  color:black;
}
</style>